import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Transliterate from "./views/Transliterate.vue";
import LanguageResources from "./views/LanguageResources.vue";
import API from "./views/API.vue";
import NotFound from "./views/NotFound.vue";
import Contact from "./views/Contact.vue";
import VideoDialogue from "./views/VideoDialogue.vue";
import KyrgyzLanguageDialogues from "./views/KyrgyzLanguageDialogues.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/transliterate",
      name: "transliterate",
      component: Transliterate
    },
    {
      path: "/api",
      name: "api",
      component: API
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact
    },
    {
      path: "/resources",
      name: "language_resources",
      component: LanguageResources
    },
    {
      path: "/kyrgyz-language-dialogues",
      name: "kyrgyz_language_dialogues",
      component: KyrgyzLanguageDialogues
    },
    {
      path: "/video/:id",
      name: "video",
      component: VideoDialogue
    },
    { path: "*", component: NotFound }
  ]
});
